import { render } from "./TictactoeView.vue?vue&type=template&id=d3da7b60&scoped=true"
import script from "./TictactoeView.vue?vue&type=script&lang=js"
export * from "./TictactoeView.vue?vue&type=script&lang=js"

import "./TictactoeView.vue?vue&type=style&index=0&id=d3da7b60&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3da7b60"]])

export default __exports__